import { Component, use, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import logIngImage from "./img/1.jpg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import LogInForm from "./logInForm";
import { setCredentials } from "../redux-state/features/user/userSlice";
import axios from "axios";
import { useNavigate, Navigate } from "react-router";
import { mainUrl } from "../urls";
import { showError } from "../utils/notifications";
import { ToastContainer } from "react-toastify";
import { setPassWordModalState } from "../redux-state/features/global-state/globalStateSlice";
const LogIn = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.userState.isAuthenticated);
  const userType = useSelector((state) => state.userState.userType);
  const [isLoading, setIsLoading] = useState(false);
  const [credError, setCredError] = useState("");
  // useEffect(() => {
  //   if (isLoggedIn) navigate("/");
  // }, [isLoggedIn]);
  const handleLogin = async (cred) => {
    const { userName, password, rememberMe } = cred;
    try {
      setIsLoading(true);
      const response = await axios.post(`${mainUrl}/auth/login`, {
        userName,
        pswd: password,
      });
      const {
        token,
        full_name,
        email,
        user_type,
        uuid,
        faculty_name,
        faculty,
        mustChangePswd,
      } = response.data;
      console.log(faculty_name, faculty);
      if (token) {
        // Store the token and user details in local storage
        localStorage.setItem("token", token);
        localStorage.setItem(
          "user",
          JSON.stringify({
            full_name,
            email,
            user_type,
            uuid,
            faculty_name,
            faculty_id: faculty,
            mustChangePswd,
          })
        );
        // Save username to localStorage if "Remember Me" is checked
        if (rememberMe) {
          localStorage.setItem("rememberedUsername", userName);
        } else {
          localStorage.removeItem("rememberedUsername"); // Clear if unchecked
        }

        // Dispatch the setCredentials action to update the Redux state
        if (parseInt(mustChangePswd) === 1) {
          dispatch(setPassWordModalState(true));
        }
        dispatch(
          setCredentials({
            token,
            user_type,
            uuid,
            email,
            userName: full_name,
            faculty_name,
            faculty_id: faculty,
            mustChangePswd,
          })
        );
        setIsLoading(false);
      } else {
        setCredError("اسم المستخدم أو كلمة المرور خاطئة ");
      }
    } catch (error) {
      const msg = [["Invalid password", "خطاء في كلمة المرور "]];
      const message = msg.filter((arr) => arr[0] === error.response.data);
      setCredError(message[1]);
      console.log(error.response.data);
      setIsLoading(false);
    }
  };
  if (isLoggedIn) {
    switch (userType) {
      case "admin":
        return <Navigate to="/admin" replace />;
      case "store_manager":
        return <Navigate to="/manager" replace />;
      case "user":
        return <Navigate to="/user" replace />;
      case "maintainer":
        return <Navigate to="/maintenance" replace />;
      case "inventory_officer":
        <Navigate to={"/inventory"} replace />;
      default:
        return (
          <Container fluid>
            <Row>
              <Col xs={6}>
                <LogInForm onLogIn={handleLogin} credError={credError} />
              </Col>
              <Col xs={6}>
                {" "}
                <Image src={logIngImage} fluid />
              </Col>
            </Row>
          </Container>
        );
    }
  }
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />{" "}
      <Container fluid>
        <Row>
          <Col xs={6}>
            <div
              className="d-flex align-items-middle"
              style={{ height: "98vh" }}
            >
              <LogInForm onLogIn={handleLogin} isLoading={isLoading} />
            </div>
          </Col>
          <Col xs={6}>
            {" "}
            <Image src={logIngImage} fluid />
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default LogIn;
// class LogIn extends Component {
//   /**
//    *
//    */
//   constructor() {
//     super();
//     this.state = {
//       username: "khaled@gmail.com",
//       password: "1234",
//     };
//   }
//   handleLogin = async (cred) => {
//     const { userName, password } = cred;
//     try {
//       const response = await axios.post("http://localhost:5000/login", {
//         userName,
//         pswd: password,
//       });
//       const { token, full_name, email, user_type, uuid } = response.data;

//       // Store the token and user details in local storage
//       localStorage.setItem("token", token);
//       localStorage.setItem(
//         "user",
//         JSON.stringify({ full_name, email, user_type, uuid })
//       );

//       // Dispatch the setCredentials action to update the Redux state
//       this.props.setCredentials({
//         token,
//         user_type,
//         uuid,
//         email,
//         userName: full_name,
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   render() {
//     return (
//       <Container fluid>
//         <Row>
//           <Col xs={6}>
//             <LogInForm onLogIn={this.handleLogin} />
//           </Col>
//           <Col xs={6}>
//             {" "}
//             <Image src={logIngImage} fluid />
//           </Col>
//         </Row>
//       </Container>
//     );
//   }
// }

// const mapDispatchToProps = { setCredentials };
// const mapStateToProps = (state) => ({});

// export default connect(mapStateToProps, mapDispatchToProps)(LogIn);
